import { render, staticRenderFns } from "./HotelDestination.vue?vue&type=template&id=3e1ccce2&"
import script from "./HotelDestination.vue?vue&type=script&lang=js&"
export * from "./HotelDestination.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\GIT\\Web-Solutions\\IPA.Naga.Web\\Themes\\Eavar.com.V2\\UINew\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3e1ccce2')) {
      api.createRecord('3e1ccce2', component.options)
    } else {
      api.reload('3e1ccce2', component.options)
    }
    module.hot.accept("./HotelDestination.vue?vue&type=template&id=3e1ccce2&", function () {
      api.rerender('3e1ccce2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "Js/Services/Tourism/HotelDestination/HotelDestination.vue"
export default component.exports